module.exports = __webpack_public_path__ + "img/aot_3.49435216.gif";